import { actions } from 'App/data-export/store/actions/actions'
import type { TLngLat } from 'App/Map/types'
import * as SimpleStore from 'stores/_utils/simple-store'

export type TDataExportStoreState = {
  visible: boolean
  formState: {
    interval: null | string
    dateRange: [null | string, null | string]
    valueTypes: string[]
    propertyId: null | string
    blockIds: string[]
    points: TLngLat[]
    irrigationZoneEmitterIds: string[]
  }
  formErrors: {
    interval: null | string
    dateRange: null | string
    valueTypes: null | string
    propertyId: null | string
    fieldAssetIds: null | string
  }
}

export const initialState: TDataExportStoreState = {
  visible: false,
  formState: {
    interval: null,
    dateRange: [null, null],
    valueTypes: [],
    propertyId: null,
    blockIds: [],
    points: [],
    irrigationZoneEmitterIds: [],
  },
  formErrors: {
    interval: null,
    dateRange: null,
    valueTypes: null,
    propertyId: null,
    fieldAssetIds: null,
  },
}

const store = SimpleStore.init<TDataExportStoreState>(initialState)

export const dataExportStore = {
  ...store,
  actions,
}
